import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { UserAssignmentFilterPipe } from './user-assignment-filter.pipe';
import { ItemReminderSummaryPipe } from './compliance-reminder-summary.pipe';
import { PropertyFilterPipe } from './property-filter.pipe';
import { UserPermissionPipe } from './user-permission/user-permission.pipe';
import { ItemSubtypePipe } from './item-subtype/item-subtype.pipe';
import { TimeTrackingTypePipe } from './time-tracking-type/time-tracking-type.pipe';
@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        PropertyFilterPipe,
        UserAssignmentFilterPipe,
        ItemReminderSummaryPipe,
        UserPermissionPipe,
        ItemSubtypePipe,
        TimeTrackingTypePipe
    ],
    exports: [
        PropertyFilterPipe,
        UserAssignmentFilterPipe,
        ItemReminderSummaryPipe,
        UserPermissionPipe,
        ItemSubtypePipe,
        TimeTrackingTypePipe
    ]
})
export class PipesModule {}